/* Normalize chat/session payloads for sidebar and history consumers. */

import { formatLocalTime, parseServerDate } from "./datetime";

function getStudentChatsPayload(payload) {
  // Older endpoints sometimes returned a plain array instead of `{ chats, sessions }`.
  if (Array.isArray(payload)) {
    return {
      chats: [],
      sessions: payload,
    };
  }

  return {
    chats: Array.isArray(payload?.chats) ? payload.chats : [],
    sessions: Array.isArray(payload?.sessions) ? payload.sessions : [],
  };
}

export function buildHistorySessions(payload) {
  // Attach preview text to the session rows shown on the history page.
  const { chats, sessions } = getStudentChatsPayload(payload);
  const previewBySessionId = new Map();

  chats.forEach((chatRow) => {
    if (!chatRow?.sessionId || previewBySessionId.has(chatRow.sessionId)) {
      return;
    }

    if (chatRow.questionText) {
      previewBySessionId.set(chatRow.sessionId, chatRow.questionText);
    }
  });

  return sessions.map((session) => ({
    ...session,
    assignmentName: session.assignmentName || "",
    preview: previewBySessionId.get(session.sessionId) || "",
  }));
}

export function buildSidebarQuestionLog(payload) {
  // Group session rows by local calendar day for the sidebar history list.
  const { chats, sessions } = getStudentChatsPayload(payload);
  const sessionRows = sessions.length > 0 ? sessions : chats;
  const questionLog = {};

  sessionRows.forEach((chat) => {
    if (!chat?.startTime) {
      return;
    }

    const sessionId = chat.sessionId;
    const date = parseServerDate(chat.startTime);
    if (!date) {
      return;
    }

    const chatDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const chatTime = formatLocalTime(chat.startTime);

    if (!questionLog[chatDate]) {
      questionLog[chatDate] = [];
    }

    const existingChat = questionLog[chatDate].find(
      (conversation) => conversation.sessionId === sessionId
    );
    if (existingChat) {
      return;
    }

    questionLog[chatDate].push({
      sessionId,
      chatSessionId: chat.chat_session_id || chat.sessionId,
      prompt: chatTime,
      courseId: chat.courseCovered,
      courseCovered: chat.courseCovered,
      assignmentId: chat.assignmentId ?? null,
      assignmentName: chat.assignmentName || "",
      messages: [],
    });
  });

  return questionLog;
}
